import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@vaiu/ui/button';
import { ArrowLeft } from 'lucide-react';
import Login from '@/components/Login';
import { i18n } from '@/utils/i18n';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col">
      {/* Header with back button */}
      <div className="p-4">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="flex items-center space-x-2 text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>{i18n.__('login.backToHome')}</span>
        </Button>
      </div>

      {/* Main login component - centered */}
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="max-w-md w-full">
          <Login />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;